import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.scss';

function iconName(name) {
  return styles[`icon-${name}`];
}

const FeatureItem = ({ feature }) => (
  <div className={`${styles.feature} media media-middle`}>
    <div className="media-object">
      <div className="app-icon-wrapper">
        <div
          className={`app-icon ${styles.appIcon} ${iconName(feature.name)}`}
        />
      </div>
    </div>
    <div className="media-body">
      <div className={styles.featureTitle}>{feature.title}</div>
      <div className={styles.featureDescription}>{feature.description}</div>
    </div>
  </div>
);

FeatureItem.propTypes = {
  feature: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired
};

export default FeatureItem;
